import { VBtnToggle } from 'vuetify/lib/components/index.mjs';

const buttonToggleDefaults: Partial<VBtnToggle> = {
  variant: 'flat',
  baseColor: 'rgb(var(--v-theme-secondary-container))',
  color: 'secondary',
};

export default buttonToggleDefaults;
